import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import { createContext } from "react";
import { useLocation } from "react-router";
import { type IAudioPlayer, useAudioPlayer } from "./use-audio-player";
import { useBytescaleContext } from "./use-bytescale-context";

interface IBytescaleContext {
  audioPlayer: IAudioPlayer;
  accountId?: string;
}

export const BytescaleContext = createContext<IBytescaleContext | undefined>(
  undefined,
);

export function BytescaleContextProvider({
  accountId,
  children,
}: PropsWithChildren & { accountId?: string }) {
  const winampAudioPlayer = useAudioPlayer(accountId);
  const location = useLocation();

  useEffect(() => {
    winampAudioPlayer.pause();
  }, [location?.pathname]);

  return (
    <BytescaleContext.Provider
      value={{ audioPlayer: winampAudioPlayer, accountId }}
    >
      {children}
    </BytescaleContext.Provider>
  );
}

export function useAudioContext() {
  const context = useBytescaleContext();
  return context.audioPlayer;
}
